import React from 'react'
import { Form } from 'react-bootstrap'

interface IProps {
  label: string
  required?: boolean
  fullWidth?: boolean
  className?: string
  children: React.ReactNode
}

export const FormFieldInput: React.FC<IProps> = ({
  label,
  required = false,
  fullWidth = false,
  className,
  children
}) => {
  const formGroupClassName = ['mb-3', 'form-group-inline', fullWidth ? 'full-width' : '', className || '']
    .filter(Boolean)
    .join(' ')

  return (
    <Form.Group className={formGroupClassName}>
      <Form.Label>
        {label}
        {required && <span className="required-indicator">*</span>}
      </Form.Label>
      {children}
    </Form.Group>
  )
}
